import { HTMLAttributes } from "react";
import {
  FieldError as ReactAriaFieldError,
  FieldErrorProps as ReactAriaFieldErrorProps,
  Text as ReactAriaText,
  TextProps as ReactAriaTextProps,
} from "react-aria-components";

import { cn, cv, type VariantProps } from "../utils";

export const ncFieldLayoutVariants = cv("gap-2 justify-items-start", {
  variants: {
    variant: {
      vertical: "grid",
      horizontal: "flex items-center justify-start gap-3",
    },
  },
  defaultVariants: {
    variant: "vertical",
  },
});

export interface NcFieldLayoutProps
  extends VariantProps<typeof ncFieldLayoutVariants>,
    HTMLAttributes<HTMLDivElement> {}

export const NcFieldLayout = ({
  variant = "vertical",
  className,
  ...props
}: NcFieldLayoutProps) => (
  <div
    data-nc="NcFieldLayout"
    className={cn(ncFieldLayoutVariants({ variant }), className)}
    {...props}
  />
);

export const ncFieldLayoutClasses = {
  error: "text-danger-active",
  description: "text-sm leading-tight",
};

const ErrorMessage = ({ className, ...props }: ReactAriaFieldErrorProps) => (
  <ReactAriaFieldError
    data-nc="NcFieldLayout.ErrorMessage"
    className={cn(ncFieldLayoutClasses.error, className)}
    {...props}
  />
);

const Description = ({ className, ...props }: ReactAriaTextProps) => (
  <ReactAriaText
    data-nc="NcFieldLayout.Description"
    slot="description"
    className={cn(ncFieldLayoutClasses.description, className)}
    {...props}
  />
);

NcFieldLayout.ErrorMessage = ErrorMessage;
NcFieldLayout.Description = Description;
